import React from 'react';

import styles from './ErrorMessage.module.scss';

const ErrorMessage = ({ children, show, style }) => {
    return show ? (
        <sup className={styles.error} role="alert" style={style}>
            {children}
        </sup>
    ) : null;
};

export default ErrorMessage;
